import { render, staticRenderFns } from "./travel-insurance-eligibility.vue?vue&type=template&id=2b0dca08&scoped=true"
import script from "./travel-insurance-eligibility.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-eligibility.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-eligibility.vue?vue&type=style&index=0&id=2b0dca08&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dca08",
  null
  
)

export default component.exports